import React, { useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import { AdvancedFilterStyles } from './styles'
import IconButton from '@material-ui/core/IconButton'
import { HiOutlineFilter } from 'react-icons/hi'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Paper, Select, TextField, Tooltip } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import Checkbox from '@material-ui/core/Checkbox'
import TipoOficio from '../../../enums/tipoOficio'
import { semNumeroNegativoInput } from '../../../utils/semNumeroNegativoInput'
import PesquisaProcessual from '../../data_display/Oficios/CriarEditarOficio/_pesquisaProcessual'
import PesquisaInteressados from '../../data_display/Oficios/CriarEditarOficio/_pesquisaInteressado'
import PesquisaAnalistaResponsavel from '../../data_display/Oficios/CriarEditarOficio/_pesquisaAnalistaResponsavel'
import PaginationComponent from '../Pagination'
import { v4 as uuid } from 'uuid'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers"
import ptBRLocale from "date-fns/locale/pt-BR"
import DateFnsUtils from "@date-io/date-fns"
import InputAdornment from "@material-ui/core/InputAdornment"
import SimNao from '../../../enums/simNao'
import OficioService from '../../../services/OficioService'
import { DateFormat, capitalize } from "../../../functions";
import { getUrlSubMenu } from '../../../utils/getUrlSubMenu';
import { useSnackbar } from "notistack"
import { OpenInNewOutlined } from '@material-ui/icons'
import webconfig from '../../../webconfig.json'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const localeMap = {
    ptBR: ptBRLocale
}

export default function AdvancedFilter() {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [pagina, setPagina] = useState(1)
    const [paginaAtual, setPaginaAtual] = useState(1)
    const [totalPaginas, setTotalPaginas] = useState(1)
    const [itensPorPagina, setItensPorPagina] = useState(10)

    const [tipoOficio, setTipoOficio] = useState('')
    const [tipoOficioError, setTipoOficioError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [numeroOficio, setNumeroOficio] = useState(0)
    const [numeroOficioError, setNumeroOficioError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [anoOficio, setAnoOficio] = useState(0)
    const [anoOficioError, setAnoOficioError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [pesquisaProcessual, setPesquisaProcessual] = useState([])
    const [errorPesquisaProcessual, setErrorPesquisaProcessual] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [pesquisaInteressados, setPesquisaInteressados] = useState([])
    const [errorPesquisaInteressados, setErrorPesquisaInteressados] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [pesquisaResponsavel, setPesquisaResponsavel] = useState([])
    const [errorPesquisaResponsavel, setErrorPesquisaResponsavel] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [dataInicio, setDataInicio] = useState(null);
    const [dataInicioError, setDataInicioError] = useState({
        errorState: false,
        errorHelperText: ''
    });

    const handleDataInicioChange = (date) => {
        setDataInicio(date)
    }

    const [dataFinal, setDataFinal] = useState(null);
    const [dataFinalError, setDataFinalError] = useState({
        errorState: false,
        errorHelperText: ''
    });

    const handleDataFinalChange = (date) => {
        setDataFinal(date)
    }

    const [dataInicioVencimento, setDataInicioVencimento] = useState(null);
    const [dataInicioVencimentoError, setDataInicioVencimentoError] = useState({
        errorState: false,
        errorHelperText: ''
    });

    const handleDataInicioVencimentoChange = (date) => {
        setDataInicioVencimento(date)
    }

    const [dataFinalVencimento, setDataFinalVencimento] = useState(null);
    const [dataFinalVencimentoError, setDataFinalVencimentoError] = useState({
        errorState: false,
        errorHelperText: ''
    });

    const handleDataFinalVencimentoChange = (date) => {
        setDataFinalVencimento(date)
    }

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const [oficioRecebido, setOficioRecebido] = useState(null);
    const handleOficioRecebidoChange = (event) => {
        setOficioRecebido(event.target.checked)
    }

    const [oficioResposta, setOficioResposta] = useState(null);
    const handleOficioRespostaChange = (event) => {
        setOficioResposta(event.target.checked)
    }

    const [oficioProrrogacao, setOficioProrrogacao] = useState(null);
    const handleOficioProrrogacaoChange = (event) => {
        setOficioProrrogacao(event.target.checked)
    }

    const [oficioRecurso, setOficioRecurso] = useState(null);
    const handleOficioRecursoChange = (event) => {
        setOficioRecurso(event.target.checked)
    }

    const [oficioNaoProcessual, setOficioNaoProcessual] = useState(null);
    const handleOficioNaoProcessualChange = (event) => {
        setOficioNaoProcessual(event.target.checked)
    }

    const [oficiosPesquisados, setOficiosPesquisados] = useState([]);
    const { enqueueSnackbar } = useSnackbar()

    const [dadosTela, setDadosTela] = useState({
        analistasDoSetor: [],
        descritores: []
    });

    const [situacaoOficio, setSituacaoOficio] = useState('');

    const realizaPesquisa = () => {
        setLoading(true);
        let idsProcessos = [];
        pesquisaProcessual.forEach(processo => {
            idsProcessos.push(processo.autuacaoId);
        });

        let idsInteressados = [];
        pesquisaInteressados.forEach(interessado => {
            idsInteressados.push(interessado.pessoaId);
        });

        let idsResponsaveis = [];
        pesquisaResponsavel.forEach(responsavel => {
            idsResponsaveis.push(responsavel.id);
        });

        let parametrosConsultaAvancada = {
            tipoOficio: tipoOficio,
            descritorSituacaoId: (situacaoOficio !== "" && situacaoOficio !== "null") ? situacaoOficio : null,
            numeroOficio: (numeroOficio !== "") ? numeroOficio : null,
            anoOficio: (anoOficio !== "") ? anoOficio : null,
            listaNumerosProcessos: (idsProcessos.length > 0) ? idsProcessos : null,
            listaIdsInteressados: (idsInteressados.length > 0) ? idsInteressados : null,
            listaIdsAnalistasResponsaveis: (idsResponsaveis.length > 0) ? idsResponsaveis : null,
            oficioRecebido: (oficioRecebido === null) ? null : oficioRecebido === true ? SimNao.SIM : SimNao.NAO,
            inicioPeriodoRecebimentoOficio: dataInicio !== null ? dataInicio.toJSON() : null,
            finalPeriodoRecebimentoOficio: dataFinal !== null ? dataFinal.toJSON() : null,
            oficioComResposta: (oficioResposta === null) ? null : oficioResposta === true ? SimNao.SIM : SimNao.NAO,
            oficioComSolicitacaoProrrogacaoPrazo: (oficioProrrogacao === null) ? null : oficioProrrogacao === true ? SimNao.SIM : SimNao.NAO,
            oficioComRecurso: (oficioRecurso === null) ? null : oficioRecurso === true ? SimNao.SIM : SimNao.NAO,
            oficioNaoProcessual: (oficioNaoProcessual === null) ? null : oficioNaoProcessual === true ? SimNao.SIM : SimNao.NAO,
            inicioPeriodoVencimentoOficio: dataInicioVencimento !== null ? dataInicioVencimento.toJSON() : null,
            finalPeriodoVencimentoOficio: dataFinalVencimento !== null ? dataFinalVencimento.toJSON() : null,
        };

        OficioService.ConsultaComFiltros(pagina, itensPorPagina, parametrosConsultaAvancada)
            .then(response => {
                setLoading(false);
                setOficiosPesquisados(response.data.oficios);

                setTotalPaginas(response.data.paginacao.totalPaginas);
                setPaginaAtual(response.data.paginacao.paginaAtual);
            })
            .catch(error => {
                setLoading(false);
                setOficiosPesquisados([]);
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        const validacao = JSON.parse(error.response.data.detail);
                        let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
                        for (let i = 0; i < validacao.Validacoes.length; i++) {

                            var itemValidado = validacao.Validacoes[i];
                            for (var propriedadeValidada in itemValidado) {
                                mensagem += itemValidado[propriedadeValidada];
                            }

                            if ((i + 1) < validacao.Validacoes.length) {
                                mensagem += "; ";
                            }
                        }

                        enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const limpaCampos = () => {
        setTipoOficio(null);
        setNumeroOficio(0);
        setAnoOficio(0);
        setPesquisaProcessual([]);
        setPesquisaInteressados([]);
        setPesquisaResponsavel([]);
        setDataInicio(null);
        setDataFinal(null);
        setOficioRecebido(null);
        setOficioResposta(null);
        setOficioProrrogacao(null);
        setOficioRecurso(null);
        setOficiosPesquisados([]);
        setTotalPaginas(1);
        setPaginaAtual(1);
        setPagina(1);
        setSituacaoOficio("")
        setDataInicioVencimento(null);
        setDataFinalVencimento(null);
        setOficioNaoProcessual(null);
    }

    const abreOficioConsultado = (chaveMenu, idOficio) => {
        let url = getUrlSubMenu(chaveMenu) + "?id=" + idOficio;
        window.open(url, '_blank');
    }

    return (
        <AdvancedFilterStyles id="AdvancedFilterStyles" >
            <IconButton onClick={handleClickOpen} className="txt-primario icon-button-notification" component="span" aria-controls="userdata-menu" aria-haspopup="true" >
                <HiOutlineFilter />
            </IconButton>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                id="dialog-advanced-filter"
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title" className="txt-primario">Pesquisa Avançada</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <FormControl variant="outlined">
                                        <InputLabel id="select-outlined-label-prioridade">Tipo</InputLabel>
                                        <Select
                                            labelId="select-outlined-label-prioridade"
                                            id="select-outlined-prioridade"
                                            value={tipoOficio}
                                            onChange={e => setTipoOficio(e.target.value)}
                                            label="Prioridade"
                                            disabled={loading}
                                            error={tipoOficioError.errorState}
                                            placeholder=" "
                                        >
                                            <MenuItem value={''}>
                                                <em>Selecione uma opção</em>
                                            </MenuItem>
                                            <MenuItem value={TipoOficio.NORMAL}>Normal</MenuItem>
                                            <MenuItem value={TipoOficio.PRAZO}>Prazo</MenuItem>
                                            <MenuItem value={TipoOficio.DEBITO_MULTA}>Débito / Multa</MenuItem>
                                            <MenuItem value={TipoOficio.MEDIDA_CAUTELAR}>Medida Cautelar</MenuItem>
                                            <MenuItem value={TipoOficio.CIRCULAR}>Circular</MenuItem>
                                        </Select>
                                        {tipoOficioError.errorState && <FormHelperText className="error-form-helper-text">{tipoOficioError.errorHelperText}</FormHelperText>}
                                    </FormControl>
                            }
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <FormControl variant="outlined">
                                        <InputLabel id="select-outlined-label-prioridade">Situação</InputLabel>
                                        <Select
                                            labelId="select-outlined-label-prioridade"
                                            id="select-outlined-prioridade"
                                            value={situacaoOficio}
                                            onChange={e => setSituacaoOficio(e.target.value)}
                                            label="Prioridade"
                                            disabled={loading}
                                            placeholder=" ">
                                            <MenuItem value={''}>
                                                <em>Selecione uma opção</em>
                                            </MenuItem>
                                            {dadosTela.descritores.map(descritor => (
                                                <MenuItem key={uuid()} value={descritor.id}>{capitalize(descritor.descricao)}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                            }
                        </Grid>

                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <FormControl variant="outlined">
                                        <TextField
                                            id="outlined-basic-ticket"
                                            variant="outlined"
                                            type="number"
                                            label="Número do Ofício"
                                            value={numeroOficio}
                                            onChange={event => semNumeroNegativoInput(event, setNumeroOficio)}
                                            error={numeroOficioError.errorState}
                                            helperText={numeroOficioError.errorHelperText}
                                            disabled={loading}
                                            placeholder=" "
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 9)
                                            }}
                                        />
                                    </FormControl>
                            }

                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <FormControl variant="outlined">
                                        <TextField
                                            id="outlined-basic-ticket"
                                            variant="outlined"
                                            type="number"
                                            label="Ano do Ofício"
                                            value={anoOficio}
                                            onChange={event => semNumeroNegativoInput(event, setAnoOficio)}
                                            error={anoOficioError.errorState}
                                            helperText={anoOficioError.errorHelperText}
                                            disabled={loading}
                                            placeholder=" "
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4)
                                            }}
                                        />
                                    </FormControl>
                            }

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <PesquisaProcessual
                                        value={pesquisaProcessual}
                                        setValue={setPesquisaProcessual}
                                        error={errorPesquisaProcessual}
                                    />
                            }

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <PesquisaInteressados
                                        value={pesquisaInteressados}
                                        setValue={setPesquisaInteressados}
                                        processos={pesquisaProcessual}
                                        error={errorPesquisaInteressados}
                                    />
                            }

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <PesquisaAnalistaResponsavel
                                        value={pesquisaResponsavel}
                                        setValue={setPesquisaResponsavel}
                                        error={errorPesquisaResponsavel}
                                    />
                            }

                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <MuiPickersUtilsProvider locale={localeMap["ptBR"]} utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="date-picker-dialog"
                                            inputVariant="outlined"
                                            label="Inicio Recebimento"
                                            format="dd/MM/yyyy"
                                            value={dataInicio}
                                            error={dataInicioError.errorState}
                                            helperText={dataInicioError.errorHelperText}
                                            disabled={loading}
                                            onChange={handleDataInicioChange}
                                            okLabel={'Selecionar'}
                                            cancelLabel={'Fechar'}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date"
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><span></span></InputAdornment>
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                            }

                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <MuiPickersUtilsProvider locale={localeMap["ptBR"]} utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="date-picker-dialog"
                                            inputVariant="outlined"
                                            label="Final Recebimento"
                                            format="dd/MM/yyyy"
                                            value={dataFinal}
                                            error={dataFinalError.errorState}
                                            helperText={dataFinalError.errorHelperText}
                                            disabled={loading}
                                            onChange={handleDataFinalChange}
                                            okLabel={'Selecionar'}
                                            cancelLabel={'Fechar'}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date"
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><span></span></InputAdornment>
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                            }
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <MuiPickersUtilsProvider locale={localeMap["ptBR"]} utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="date-picker-dialog"
                                            inputVariant="outlined"
                                            label="Inicio Vencimento"
                                            format="dd/MM/yyyy"
                                            value={dataInicioVencimento}
                                            error={dataInicioVencimentoError.errorState}
                                            helperText={dataInicioVencimentoError.errorHelperText}
                                            disabled={loading}
                                            onChange={handleDataInicioVencimentoChange}
                                            okLabel={'Selecionar'}
                                            cancelLabel={'Fechar'}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date"
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><span></span></InputAdornment>
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                            }

                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            {
                                loading
                                    ?
                                    <Skeleton id="skeleton-default-input" animation="wave" />
                                    :
                                    <MuiPickersUtilsProvider locale={localeMap["ptBR"]} utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="date-picker-dialog"
                                            inputVariant="outlined"
                                            label="Final Vencimento"
                                            format="dd/MM/yyyy"
                                            value={dataFinalVencimento}
                                            error={dataFinalVencimentoError.errorState}
                                            helperText={dataFinalVencimentoError.errorHelperText}
                                            disabled={loading}
                                            onChange={handleDataFinalVencimentoChange}
                                            okLabel={'Selecionar'}
                                            cancelLabel={'Fechar'}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date"
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><span></span></InputAdornment>
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                            }
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            {
                                oficioRecebido === null
                                    ?
                                    <Checkbox
                                        checked={oficioRecebido != null ? oficioRecebido : false}
                                        onChange={handleOficioRecebidoChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        indeterminate
                                    />
                                    :
                                    <Checkbox
                                        checked={oficioRecebido != null ? oficioRecebido : false}
                                        onChange={handleOficioRecebidoChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                            }
                            <span className="description-switch-label-filter">Ofícios recebidos</span>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            {
                                oficioResposta === null
                                    ?
                                    <Checkbox
                                        checked={oficioResposta != null ? oficioResposta : false}
                                        onChange={handleOficioRespostaChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        indeterminate
                                    />
                                    :
                                    <Checkbox
                                        checked={oficioResposta != null ? oficioResposta : false}
                                        onChange={handleOficioRespostaChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                            }
                            <span className="description-switch-label-filter">Ofícios com resposta</span>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            {
                                oficioProrrogacao === null
                                    ?
                                    <Checkbox
                                        checked={oficioProrrogacao != null ? oficioProrrogacao : false}
                                        onChange={handleOficioProrrogacaoChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        indeterminate
                                    />
                                    :
                                    <Checkbox
                                        checked={oficioProrrogacao != null ? oficioProrrogacao : false}
                                        onChange={handleOficioProrrogacaoChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                            }
                            <span className="description-switch-label-filter">Ofícios com solicitação de prorrogação de prazo</span>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            {
                                oficioRecurso === null
                                    ?
                                    <Checkbox
                                        checked={oficioRecurso != null ? oficioRecurso : false}
                                        onChange={handleOficioRecursoChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        indeterminate
                                    />
                                    :
                                    <Checkbox
                                        checked={oficioRecurso != null ? oficioRecurso : false}
                                        onChange={handleOficioRecursoChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                            }
                            <span className="description-switch-label-filter">Ofícios com recurso</span>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            {
                                oficioNaoProcessual === null
                                    ?
                                    <Checkbox
                                        checked={oficioNaoProcessual != null ? oficioNaoProcessual : false}
                                        onChange={handleOficioNaoProcessualChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        indeterminate
                                    />
                                    :
                                    <Checkbox
                                        checked={oficioNaoProcessual != null ? oficioNaoProcessual : false}
                                        onChange={handleOficioNaoProcessualChange}
                                        className="txt-primario"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                            }
                            <span className="description-switch-label-filter">Ofícios não processuais</span>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className="action-search-filters-poopover">
                                <Button className='btn-clear-search-filters' onClick={limpaCampos}>Limpar</Button>
                                <Button className='btn-send-search-filters' onClick={e => realizaPesquisa(e)}>Filtrar</Button>
                            </div>
                        </Grid>
                    </Grid>
                    {
                        !loading && oficiosPesquisados.length > 0 && (
                            <Paper elevation={4} id="paper-card">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <AdvancedFilterStyles.Title>Resultados encontrados</AdvancedFilterStyles.Title>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <PaginationComponent
                                            loading={loading}
                                            pagina={pagina}
                                            setPagina={setPagina}
                                            paginaAtual={paginaAtual}
                                            setPaginaAtual={setPaginaAtual}
                                            totalPaginas={totalPaginas}
                                            itensPorPagina={itensPorPagina}
                                            comtemTitulo={false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ margin: '25px 0' }}>
                                            <TableContainer >
                                                <Table size="small" aria-label="a dense table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Processo</TableCell>
                                                            <TableCell>Número</TableCell>
                                                            <TableCell>Data</TableCell>
                                                            <TableCell align="left">Tipo do Ofício</TableCell>
                                                            <TableCell align="left">Situação Atual</TableCell>
                                                            <TableCell>Vencimento</TableCell>
                                                            <TableCell align="left">Interessado</TableCell>
                                                            <TableCell align="center">Ações</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <>
                                                            {
                                                                oficiosPesquisados.map(oficio => (
                                                                    <TableRow key={uuid()} style={{ height: 25 }}>
                                                                        <TableCell component="th" scope="row">{oficio.processo}</TableCell>
                                                                        <TableCell component="th" scope="row">{oficio.numero > 0 ? oficio.numero + "/" + oficio.ano : ""}</TableCell>
                                                                        <TableCell align="left">{DateFormat(oficio.dataCriacao)}</TableCell>
                                                                        <TableCell align="left">{oficio.tipoOficio}</TableCell>
                                                                        <TableCell align="left">{oficio.situacao}</TableCell>
                                                                        <TableCell align="left">{oficio.dataVencimento != null ? DateFormat(oficio.dataVencimento) : ""}</TableCell>
                                                                        <TableCell align="left">{oficio.nomeInteressado}</TableCell>
                                                                        <TableCell align="left"><Tooltip title="Visualizar Ofício em Nova Guia" placement="top"><Button className="btn-visualizar-oficio" onClick={() => abreOficioConsultado(oficio.chaveSubMenu, oficio.id)}><OpenInNewOutlined /></Button></Tooltip></TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                        </>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                        )
                    }
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </AdvancedFilterStyles >
    )
}